module.exports = __webpack_public_path__ + "static/img/pic3.06cb33f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic3.jpg
// module id = MYKu
// module chunks = 0